module.exports = __webpack_public_path__ + "static/media/Gratitude.f3d6f746.png";